module.exports = __webpack_public_path__ + "static/media/NEX.d264ca06.svg";